import { Select } from '@mantine/core';
import { resolutions } from './TextureResolution.data';
import { Wrapper } from './TextureResolution.style';

export type TextureResolutionProps = {
  resolution: TexturesResolution;
  onChange: (value: TexturesResolution) => void;
};

export function TextureResolution(props: TextureResolutionProps) {
  const { resolution } = props;

  return (
    <Wrapper className='TextureResolution-wrapper' data-testid='TextureResolution-wrapper'>
      <Select
        placeholder='Res'
        data={resolutions}
        size='sm'
        value={resolution}
        onChange={(value) => props.onChange(value as any)}
      />
    </Wrapper>
  );
}

export default TextureResolution;
